export const APP_PERMISSIONS_KEY = "audalize.perms"

export class ServiceConstants { //dummy name so this file can be export as a module
}
